export async function saveFieldAllocation(field: string, field_data: string) {
    // do something else if localhost (local testing)
    if (window.location.host.includes('localhost')) {
        console.log(`Skipping saveFieldAllocation for field ${field} due to localhost.`);
        return new Response(JSON.stringify({ message: 'Localhost detected. No match data fetched.' }));
    }
    const response = await fetch('https://bct-scoreboard-v2.taegener.eu/web/access/save_single_field_allocation.php', {
        mode: 'cors',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
            field,
            field_data,
        }),
    });
    if (!response.ok) {
        throw new Error(`[FieldController.ts] Error saving field allocation. HTTP status: ${response.status}`);
    }
    console.info(`[FieldController.ts] Saving field allocation: ${response}}`);
    return response;
}